module.exports = __webpack_public_path__ + "media/src/images/landing/cup-64b8fd8c02b283cd8d073949772e0544.svg";